module.exports = __webpack_public_path__ + "img/logo.d3678fc3.png";